import type { PlainButtonProps } from '@customerio/pluma-components/react';
import { Button, Tooltip, TooltipContent } from '@customerio/pluma-components/react';
import type { IconName } from '@customerio/pluma-icons';
import type { Ref } from 'react';
import { mergeRefs } from 'react-merge-refs';

/**
 * Icon Button component for the top navigation actions.
 */
export function IconButton({
  icon,
  label,
  tooltip,
  isLoading,
  children,
  showLabel = false,
  size = 'sm',
  ref,
  ...rest
}: {
  icon?: IconName;
  size?: 'sm' | 'md';
  label: string;
  tooltip?: React.ReactNode;
  isLoading?: boolean;
  children?: React.ReactNode;
  showLabel?: boolean;
  ref?: Ref<HTMLButtonElement>;
} & PlainButtonProps) {
  return (
    <Tooltip isDisabled={tooltip == null} isCustom={true}>
      {(context) => (
        <>
          <Button
            ref={mergeRefs([ref, context.reference.setReference])}
            icon={icon}
            isIconOnly={icon != null && showLabel !== true}
            aria-label={showLabel ? undefined : label}
            variant="subtle"
            size={size}
            isLoading={isLoading}
            {...context.reference.getReferenceProps(rest as any)}
          >
            {showLabel ? label : null}
            {children}
          </Button>
          <TooltipContent>{tooltip}</TooltipContent>
        </>
      )}
    </Tooltip>
  );
}
